if (!customElements.get('compare-full-row')) {
    class CompareFullRow extends HTMLElement {

        constructor() {
            super();
            this.parent = null;
            this.quantityInput = this.querySelector('quantity-input');
            this.quantityContainer = this.querySelector('[data-qty]');
            this.availableFromContainer = this.querySelector('[data-available-from]');
            this.availableContainer = this.querySelector('[data-available]');
            this.variantId = parseInt(this.dataset.variantId);
            this.allowMultiSelect = this.dataset.multiselect == 'true';
            this.replaceAlternative = this.dataset.replaceAlternative == 'true';
            this.isMain = this.dataset.isMain == "true";
            this.alternativesUnlimited = !this.isMain && this.dataset.alternativesUnlimited == 'true';
            this.approvalIdentifier = null;
            this.productIdentifier = null;
            this.depositReference = null;
            this.key = null
            this.price = this.dataset.price;
            this.productId = null;
            this.productHandle = null;
            this.item = null;
            this.available = null;
            this.remaining = null;
            this.quantities = {};
        }

        set quantity(value) {
            this.input.value = value;
        }

        get quantity() {
            return Number(this.input.value || '0');
        }

        connectedCallback() {
            document.addEventListener('compare:full:row:whoami', this.handleWhoami.bind(this));
        }

        disconnectedCallback() {
            document.removeEventListener('compare:full:row:whoami', this.handleWhoami.bind(this));
            this.quantityInput.removeEventListener('change', this.handleChange.bind(this));
            document.removeEventListener(`alternative:quantity-changed:${this.productIdentifier}`, this.handleChanged.bind(this));
        }

        handleWhoami({ detail }) {
            this.parent = detail;
            this.init();
        }

        init() {
            this.approvalIdentifier = `${this.parent.key}_${this.parent.variant_id}`;
            this.productIdentifier = this.parent.properties['_identifier'];
            this.depositReference = this.parent.properties['_deposit_reference'];
            this.key = this.parent.key;
            this.productId = this.parent.product_id;
            this.productHandle = this.parent.handle;
            this.item = JSON.parse(document.querySelector(`[data-item="${this.key}"]`)?.innerText);

            this.available = this.replaceAlternative ? this.parent.quantity : this.parent.quantity - parseInt(this.parent.properties['_available']);
            this.remaining = this.available;

            this.quantityContainer.innerHTML = this.item.quantity;
            this.availableContainer.innerHTML = this.parent.properties['_available'];

            this.quantities[this.approvalIdentifier] = {
                productId: this.productId,
                price: this.price,
                quantity: 0,
                depositReference: this.depositReference,
                productHandle: this.productHandle,
            };

            this.classList.remove('hidden');

            this.quantityInput.addEventListener('change', this.handleChange.bind(this));
            document.addEventListener(`alternative:quantity-changed:${this.productIdentifier}`, this.handleChanged.bind(this));

            document.dispatchEvent(new CustomEvent(`alternative:state-changed:${this.key}`, { bubbles: true, detail: this.quantities }));
        }

        handleChanged({ detail }) {
            const { caller, quantity, price, productId, depositReference, productHandle } = detail;

            this.quantities[caller] = {
                productId: productId,
                price: price,
                quantity: quantity,
                depositReference: depositReference,
                productHandle: productHandle,
            };


            if (this.alternativesUnlimited) {
                if (this.quantityInput.quantity < 0) {
                    this.quantityInput.quantity = 0;
                }
            } else {

                if (!this.allowMultiSelect && caller != this.approvalIdentifier) {
                    this.quantities[caller].quantity = 0;
                    this.quantityInput.quantity = '';
                }
                this.remaining = this.available - Object.values(this.quantities).reduce((acc, current) => acc + current.quantity, 0);
            }

            this.quantityInput.disabled = (this.remaining == 0 && this.quantities[this.approvalIdentifier].quantity == 0);

            if (caller == this.approvalIdentifier) {
                document.dispatchEvent(new CustomEvent(`alternative:state-changed:${this.key}`, { bubbles: true, detail: this.quantities }));
            }
        }

        handleChange() {
            if (!this.alternativesUnlimited && this.quantityInput.quantity > parseInt(this.parent.properties['_available'])) {
                this.quantityInput.quantity = parseInt(this.parent.properties['_available']);
            }

            if (this.alternativesUnlimited) {
                if (this.quantityInput.quantity < 0) {
                    this.quantityInput.quantity = 0;
                }
            } else {
                if (this.quantityInput.quantity > this.available && this.remaining > 0) {
                    this.quantities[this.approvalIdentifier].quantity = this.remaining;
                }
                if (this.remaining <= 0 && this.quantityInput.quantity > this.quantities[this.approvalIdentifier].quantity || this.quantityInput.quantity > this.available) {
                    this.quantityInput.quantity = this.quantities[this.approvalIdentifier].quantity;
                }
            }

            document.dispatchEvent(
                new CustomEvent(`alternative:quantity-changed:${this.productIdentifier}`, {
                    bubbles: true,
                    detail: {
                        caller: this.approvalIdentifier,
                        quantity: this.quantityInput.quantity,
                        price: this.price,
                        productId: this.productId,
                        depositReference: this.depositReference,
                        productHandle: this.productHandle
                    }
                })
            );
        }
    }

    customElements.define('compare-full-row', CompareFullRow);
}